export const ROUTES = {
  root: '/',
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  dashboard: '/dashboard',
  pos: '/pos',
  products: '/products',
  productNew: '/products/new',
  productEdit: (id: string | number = ':id') => `/products/${id}/edit`,
  productTopProducts: '/products/top-products',
  categories: '/products/categories',
  inventory: '/inventory',
  purchaseOrders: '/inventory/purchase-orders',
  purchaseOrderNew: '/inventory/purchase-orders/new',
  suppliers: '/inventory/suppliers',
  partners: '/clients',
  reviews: '/reviews',
  discover: '/discover',
  projects: '/projects',
  supplierNew: '/inventory/suppliers/new',
  sales: '/sales',
  saleDetail: (id: string | number = ':id') => `/sales/${id}`,
  refunds: '/sales/refunds',
  receivables: '/sales/receivables',
  rentals: '/sales/rentals',
  orders: '/orders',
  quotes: '/quotes',
  quoteNew: '/quotes/new',
  quoteEdit: (id: string | number = ':id') => `/quotes/${id}/edit`,
  quoteDetail: (id: string | number = ':id') => `/quotes/${id}`,
  customers: '/customers',
  customerNew: '/customers/new',
  customerDetail: (id: string | number = ':id') => `/customers/${id}`,
  expenses: '/expenses',
  expenseNew: '/expenses/new',
  expenseEdit: (id: string | number = ':id') => `/expenses/${id}/edit`,
  expenseCategories: '/expenses/categories',
  employees: '/employees',
  employeeAdjustments: (id: string | number = ':id') => `/employees/${id}/adjustments`,
  users: '/users',
  userNew: '/users/new',
  userEdit: (id: string | number = ':id') => `/users/${id}/edit`,
  roles: '/roles',
  reports: '/reports',
  reportSales: '/reports/sales',
  reportPurchases: '/reports/purchases',
  reportExpenses: '/reports/expenses',
  reportInventory: '/reports/inventory',
  reportStatement: '/reports/statement',
  settings: '/settings',
  account: '/account',
  auditLogs: '/audit-logs',
  notFound: '*',
} as const;
